module.exports = __webpack_public_path__ + "img/kent-state-logo.94ec3f12.png";